import { render, staticRenderFns } from "./profileSecurity.vue?vue&type=template&id=4a7f19e4&scoped=true&"
import script from "./profileSecurity.vue?vue&type=script&lang=js&"
export * from "./profileSecurity.vue?vue&type=script&lang=js&"
import style0 from "./profileSecurity.vue?vue&type=style&index=0&id=4a7f19e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7f19e4",
  null
  
)

export default component.exports